import React from 'react'
import SemRushForm from './SemRushForm'
import SetTitle from '../../utils/set_title'
import Header from '../../components/Headers/Header'

export default function SemRush() {
  SetTitle('SemRush')
  const description =
    'Una volta raccolte le keyword dal file e dal form verrà ritornato un report per l\'endpoint selezionato. I report conterranno le seguenti metriche: volume, CPC, numero di risultati sul database della location selezionata, riguardanti le  keyword alla mail inserita.'

  return (
    <Header
      iconClass="fa fa-fire"
      title="SemRush"
      docLink="/docs/ranking_tools/sem-rush/"
      description={description}
    >
      <SemRushForm />
    </Header>
  )
}